import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  Input,
  computed,
  signal,
} from '@angular/core';
import { EnumOptions } from '@kinet-open-network/shared/data-access/model';

@Component({
  selector: 'kon-indicator',
  standalone: true,
  imports: [CommonModule],
  template: `<div class="flex flex-row gap-2 align-middle items-center">
    <div
      [ngClass]="{
        'flex-none rounded-full p-1': true,
        'bg-danger-400/20 text-danger-600': currentColor() === 'danger',
        'bg-warn-400/20 text-warn-600': currentColor() === 'warn',
        'bg-success-400/20 text-success-600': currentColor() === 'success',
        'bg-gray-400/20 text-gray-400': currentColor() === 'none',
        'bg-primary-400/20 text-primary-600': currentColor() === 'primary',
        'bg-purple-400/20 text-purple-600': currentColor() === 'info',
      }"
    >
      <div class="h-1.5 w-1.5 rounded-full bg-current"></div>
    </div>
    <span *ngIf="currentLabel()" class="">{{ currentLabel() }}</span>
  </div>`,
  styles: ``,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IndicatorComponent {
  @Input() color?: 'danger' | 'warn' | 'success' | 'none' | 'primary';
  @Input() icon?: 'times' | 'exclamation' | 'check' | 'minus';
  @Input() label?: string | null = null;
  @Input() options?: Map<string, EnumOptions>;

  valueSignal = signal<unknown | undefined>(undefined);
  @Input() set value(val: unknown | undefined) {
    this.valueSignal.set(val);
  }

  currentOption = computed(() => {
    let o = this.options?.get(this.valueSignal()?.toString() ?? '_default');
    if (o == null) {
      o = this.options?.get('_default');
    }
    return o;
  });

  currentLabel = computed(() =>
    this.label ? this.label : this.currentOption()?.label,
  );

  currentColor = computed(() =>
    this.color ? this.color : this.currentOption()?.color ?? 'none',
  );

  statusIcon = computed(() => {
    switch (this.currentColor()) {
      case 'success':
        return 'check';
      case 'danger':
        return 'times';
      case 'warn':
        return 'exclamation';
      case 'none':
        return 'minus';
      default:
        return 'minus';
    }
  });

  currentIcon = computed(() =>
    this.icon ? this.icon : this.currentOption()?.icon ?? this.statusIcon(),
  );
}
